import { render, staticRenderFns } from "./member-table.vue?vue&type=template&id=c1aeb1a8&scoped=true"
import script from "./member-table.vue?vue&type=script&lang=ts"
export * from "./member-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1aeb1a8",
  null
  
)

export default component.exports